module.exports = __webpack_public_path__ + "img/gpt-image-demo-1.8314ac92.webp";